import authRespository from '@/repositories/auth/auth'

class AuthSerivice {
  async userLogin (params) {
    const data = await authRespository.login(params);
    return data || [];
  };
  async getPublicKey () {
    const data = await authRespository.getPublicKey();
    return data.data || [];
  };
  async verifyUserInfo () {
    const data = await authRespository.verifyUserInfo();
    return data.data || [];
  };
  async setIP (loginLog) {
    const data = await authRespository.setIP(loginLog);
    return data.data;
  }
};

module.exports = new AuthSerivice();



// WEBPACK FOOTER //
// ./src/services/login.service.js